import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import Parachute from 'images/icons/Parachute'

const Wrapper = styled.div`
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-content: center;
  border-bottom: 2px solid rgba(222, 222, 222, 1);
  font-style: italic;
  font-weight: 900;
  font-size: 18px;
`

const ImageContainer = styled.div`
  display: flex;
  align-content: center;
  justify-content: center;
  padding-bottom: 16px;
  padding-left: 16px;
`

function GiftTop (props) {
  const { bonusAmount } = props
  return (
    <Wrapper>
      {
        bonusAmount > 0 &&
        <ImageContainer>
          <Parachute/>
        </ImageContainer>
      }
    </Wrapper>
  )
}

GiftTop.propTypes = {
  bonusAmount: PropTypes.number.isRequired,
  onUsText: PropTypes.string.isRequired,
}

export default GiftTop



// WEBPACK FOOTER //
// ./src/molecules/PromoNotifications/components/GiftTop.js